import { Region } from "resource-planner-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";
import {
  fetchAllList,
  fetchListPage,
  PaginatedListRequest,
  PaginatedListResponse
} from "../utils/PaginatedListService";

export interface RegionService {
  fetch(): Promise<Region[]>;
  fetchPage(request?: PaginatedListRequest): Promise<PaginatedListResponse<Region>>;
  delete(id: string): Promise<void>;
  persist(item: Region): Promise<Region>;
}

class HTTPRegionService implements RegionService {
  constructor(private endpoint: string) {}

  async fetch(): Promise<Region[]> {
    return fetchAllList<Region>(`${this.endpoint}/regions`, (url) =>
      fetchService.fetch(url, {}).then((r) => r.json())
    ).catch((): any[] => []);
  }

  async fetchPage(
    request: PaginatedListRequest = {}
  ): Promise<PaginatedListResponse<Region>> {
    return fetchListPage<Region>(
      `${this.endpoint}/regions`,
      (url) => fetchService.fetch(url, {}).then((r) => r.json()),
      request
    ).catch(() => ({ items: [] as Region[] }));
  }

  async delete(id: string): Promise<void> {
    return fetchService
      .fetch(`${this.endpoint}/regions/${id}`, {
        method: "DELETE",
      })
      .then();
  }

  async persist(item: Region): Promise<Region> {
    return fetchService
      .fetch(`${this.endpoint}/regions`, {
        method: "POST",
        body: JSON.stringify(item),
      })
      .then((r) => r.json());
  }
}

const regionService: RegionService = new HTTPRegionService(env.endpoint);

export default regionService;
